import React from 'react';

interface HighlightedTextProps {
  text: string;
  highlightWords?: string[];
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({ text, highlightWords }) => {
  const parts = text?.split(/\b/);

  return (
    <span>
      {parts?.map((part, index) => {
        if (highlightWords && highlightWords.includes(part.toLowerCase())) {
          return (
            <span key={index} style={{ backgroundColor: 'yellow' }}>
              {part}
            </span>
          );
        } else {
          return <span key={index}>{part}</span>;
        }
      })}
    </span>
  );
};
